import { createSelector } from 'reselect'
import createVisitorsSelector from '../../../selectors/createVisitorsSelector'

const getId = (state, props) => props.cardContext.id

export const getCurrentUserId = (state, props) => state.kanbo.currentUser.id

export const createIsAnyVisitorInCardSelector = (visitorsSelector) => {
  return createSelector(
    [
      visitorsSelector,
      getCurrentUserId
    ],
    (
      visitors,
      currentUserId
    ) =>
      visitors.some(visitor =>
        visitor.id !== currentUserId &&
        visitor.action &&
        visitor.action === 'Being'
      )
  )
}

export default () => {
  const visitorsSelector = createVisitorsSelector(getId)
  const isAnyVisitorInCardSelector = createIsAnyVisitorInCardSelector(visitorsSelector)

  return createSelector(
    [
      visitorsSelector,
      isAnyVisitorInCardSelector,
    ],
    (
      visitors,
      isAnyVisitorInCard,
    ) => ({
      visitors,
      isAnyVisitorInCard,
    })
  )
}
